import { Five9Client } from './client';
import { Five9BridgeClient } from './bridge-client';
import { get } from 'lodash';
export default function OpenBridgeFlow(onStatusUpdate, onClose){
  return new Promise((resolve) => {
    const bridge = new Five9BridgeClient();
    bridge.open(
      (msg) => {
        const statusMessage = get(JSON.parse(msg), 'payload.securePayStatusMessage');
        onStatusUpdate(statusMessage);
      },
      (url) => {
        resolve(url);
      },
      onClose
    );
  });
}
